import { securityCards } from "../data/homePageContent";

export function SecuritySection() {
  return (
    // A full-bleed band, like the trust strip, with the heading on top like every other section.
    // It used to be a rounded navy card floating inside a white section — the only part of the page
    // with a visible edge, and a second dark treatment in a different shape from the first.
    <section className="section-band section-band--dark" id="security">
      <div className="site-shell">
        <div className="section-heading section-heading--light reveal">
          <p className="kicker kicker--light">Security &amp; privacy</p>
          <h2>Tax data demands the highest standard of care.</h2>
          <p className="section-lede">
            Your documents move through a system built to keep them private, and every return is
            reviewed, finalized, and e-filed by an IRS-registered preparer. Core hosting is in U.S.
            regions, your data is never sold, and provider retention and model-use controls follow
            the applicable terms and environment configuration.
          </p>
        </div>
        <div className="security-grid reveal reveal--delay">
          {securityCards.map((card) => (
            <article className="security-card" key={card.title}>
              <h3>{card.title}</h3>
              <p>{card.body}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
